import * as React from 'react';
import { apiBaseUrl } from '../api';
import * as moment from 'moment';
import query from '../router/query';
// import auth from './auth';

interface ISlot {
  id: number;
  name: string;
  startTime: Date;
  endTime: Date;
  duration: number;
  startLocation: string;
  endLocation: string;
}

interface IState {
  slots: ISlot[];
  durationTotal: number;
  startDate: Date;
  endDate: Date;
  error: string | undefined;
  loading: boolean;
  names: string[];
  selectedName: string | undefined;
  selectedMonthShift: number;
}

export default class List extends React.Component<{}, IState> {
  nameSelect: HTMLSelectElement | null;
  monthSelect: HTMLSelectElement | null;

  constructor(props: {}) {
    super(props);

    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const q = query();
    this.state = {
      slots: [],
      startDate: new Date(year, month, 1),
      endDate: new Date(year, month + 1),
      error: undefined,
      loading: false,
      durationTotal: 0,
      names: ['matej', 'arul'],
      selectedName: q.name,
      selectedMonthShift: q.monthShift
        ? Number(q.monthShift)
        : 0
    };
  }

  componentWillMount() {
    this.fetchSlots();
  }

  render() {
    const { durationTotal /*, selectedName*/ } = this.state;
    return (
      <div className="textContent">
        <div className="subNav">
          <a
            href={'/time/track'}
          >Tracking</a>
        </div>
        <div className="subNav">
          <span>
            Name: &nbsp;
            {this.nameElements() /*auth() ? this.nameElements() : <strong>{selectedName}</strong>*/}
          </span>
          &nbsp;&nbsp;&nbsp;
          <span>
            Month: &nbsp;
            {this.monthElements()}
          </span>
        </div>
        <div>&nbsp;</div>
        <table className="mainTable">
          <tbody>
            <tr>
              <th>Id</th>
              <th>Name</th>
              <th>Duration</th>
              <th>Start time</th>
              <th>Start location</th>
              <th>End location</th>
            </tr>
            {this.slotElements()}
          </tbody>
        </table>
        <div>&nbsp;</div>
        <div>
          <strong>Total duration: {durationTotal.toFixed(2)} h</strong>
        </div>
      </div>
    );
  }

  onNameChange = () => {
    if (!this.nameSelect) {
      return;
    }
    const { selectedMonthShift } = this.state;
    location.href =
      location.origin +
      location.pathname +
      `?name=${this.nameSelect.value}&monthShift=${selectedMonthShift}`;
  };

  onMonthChange = () => {
    if (!this.monthSelect) {
      return;
    }
    const { selectedName } = this.state;
    const name = selectedName ? selectedName : '*';
    location.href =
      location.origin +
      location.pathname +
      `?name=${name}&monthShift=${this.monthSelect.value}`;
  };

  slotElements = () => {
    const { slots } = this.state;
    const slotElements: React.ReactNode[] = [];
    for (const slot of slots) {
      const strStartTime = moment(slot.startTime).format(
        'ddd, MMM D, YYYY, h:mm'
      );
      const strDuration = (slot.duration && slot.duration.toFixed(2)) || 0;
      slotElements.push(
        <tr key={slot.id}>
          <td>{slot.id}</td>
          <td>{slot.name}</td>
          <td>{strDuration} h</td>
          <td>{strStartTime}</td>
          <td>{formatLocationString(slot.startLocation)}</td>
          <td>{formatLocationString(slot.endLocation)}</td>
        </tr>
      );
    }
    return slotElements;
  };

  monthElements = () => {
    const { selectedMonthShift } = this.state;
    const monthElements: React.ReactNode[] = [];
    const now = moment();
    for (let monthShift = 1; monthShift > -8; monthShift--) {
      const monthDate = now.clone().add(monthShift, 'months');
      monthElements.push(
        <option key={monthShift} value={monthShift}>
          {monthDate.format('MMMM YYYY')}
        </option>
      );
    }
    return (
      <select
        ref={element => (this.monthSelect = element)}
        name="month"
        onChange={this.onMonthChange}
        defaultValue={String(selectedMonthShift)}
      >
        {monthElements}
      </select>
    );
  };

  nameElements = () => {
    const { names, selectedName } = this.state;
    const nameElements: React.ReactNode[] = [
      <option key="any" value="*">
        *
      </option>
    ];
    for (const name of names) {
      nameElements.push(
        <option key={name.toLowerCase()} value={name.toLowerCase()}>
          {name}
        </option>
      );
    }
    return (
      <select
        ref={element => (this.nameSelect = element)}
        name="name"
        onChange={this.onNameChange}
        defaultValue={selectedName ? selectedName.toLowerCase() : '*'}
      >
        {nameElements}
      </select>
    );
  };

  fetchSlots = async () => {
    const { selectedName, selectedMonthShift } = this.state;
    this.setState({ loading: true, error: undefined });
    try {
      let url = `${apiBaseUrl}time/slots`;
      let questionMarkAdded = false;
      if (selectedName && selectedName !== '*') {
        url += `?name=${encodeURI(selectedName)}`;
        questionMarkAdded = true;
      }
      if (selectedMonthShift !== 0) {
        const date = moment().add(selectedMonthShift, 'months');
        url += questionMarkAdded ? '&' : '?';
        questionMarkAdded = true;
        url += `monthDate=${encodeURI(date.toISOString())}`;
      }
      const result = await fetch(url);
      if (result.status !== 200) {
        throw new Error('Invalid status code');
      }
      const json = await result.json();
      let durationTotal = 0;
      const slots = [];
      for (const slot of json.slots) {
        if (slot.duration) {
          durationTotal += slot.duration;
        }
        slots.push({
          ...slot,
          startTime: new Date(slot.startTime),
          endTime: new Date(slot.endTime)
        });
      }
      this.setState({
        loading: false,
        slots,
        durationTotal,
        names: json.names
      });
    } catch (error) {
      console.log('error', error);
      this.setState({ loading: false, error: 'Failed to fetch' });
    }
  };
}

function formatLocationString(location: string) {
  const arr = location.split(',');
  const lat = Number(arr[0]);
  const lng = Number(arr[1]);
  return `${lat.toFixed(4)},${lng.toFixed(4)}`;
}



// WEBPACK FOOTER //
// ./src/time/List.tsx